
import { Spin } from "antd";
import { useState, useEffect } from "react";
import HousingCompanyService from "services/services/HousingCompanyService";
import './GeneratePDF.scss'

function ListOfAllShareholdersPDF(props: any) {
    const [loading, setLoading] = useState<boolean>(false);
    const [listsData, setListsData] = useState<any>([]);

    useEffect(() => {
        getAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAllData = () => {
        setLoading(true);

        let object: any = {};
        object.name = props?.id;

        HousingCompanyService
        .getShareholderData(object)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                let list:any = response?.data?.data;

                list = list.sort((a:any, b:any) => {
                    if(!a.shareholder_name){
                        a.shareholder_name = "";
                    }
                    if(!b.shareholder_name){
                        b.shareholder_name = "";
                    }
                    return a.shareholder_name.localeCompare(b.shareholder_name, undefined, {numeric: true, sensitivity: 'base'});
                }).sort((a:any, b:any) => {
                    if(!a.apartment_name){
                        a.apartment_name = "";
                    }
                    if(!b.apartment_name){
                        b.apartment_name = "";
                    }
                    return a.apartment_name.localeCompare(b.apartment_name, undefined, {numeric: true, sensitivity: 'base'});
                }).sort((a:any, b:any) => {
                    if(!a.apartment_type){
                        a.apartment_type = "";
                    }
                    if(!b.apartment_type){
                        b.apartment_type = "";
                    }
                    return a.apartment_type.localeCompare(b.apartment_type, undefined, {numeric: true, sensitivity: 'base'});
                })
                setListsData(list);
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    };

    return (
        <>
            <Spin spinning={loading}>
                <div className="print table-responsive">
                    <table className="table table-sm table-bordered cu-fs-10 mb-0">
                        <thead className="cu-bg-green">
                            <tr>
                                <th className="text-left">{props?.TranslateString('Apartment Name')}</th>
                                <th className="text-left">{props?.TranslateString('apartmenttype')}</th>
                                <th className="text-left">{props?.TranslateString('Shareholder name')}</th>
                                <th className="text-left">{props?.TranslateString('home_address_of_shareholder')}</th>
                                <th className="text-right">{props?.TranslateString('total_share_of_that_shareholder')}</th>
                                {
                                    props?.externalCustomer ?
                                     "" : 
                                     <th className="text-right">{props?.TranslateString('ownership_percentage')}</th>
                                }
                                <th className="text-right">{props?.TranslateString('percent_of_total_shares')}</th>
                                <th className="text-right">{props?.TranslateString('of_total_shares')}</th>
                                {
                                    props?.externalCustomer ?
                                     "" : 
                                     <th className="text-right">{props?.TranslateString('percent_of_total_m2')}</th>
                                }
                                <th className="text-left" style={{width: "65px"}}>{props?.TranslateString('Business Id')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listsData?.map((element:any)=>{
                                    return <tr key={Math.random()}>
                                        <td className="text-left">{element?.apartment_name}</td>
                                        <td className="text-left">{element?.apartment_type}</td>
                                        <td className="text-left">{element?.shareholder_name}</td>
                                        <td className="text-left">{element?.shareholder_address}</td>
                                        <td className="text-right">{element?.total_shares}</td>
                                        {
                                            props?.externalCustomer ?
                                            "" : 
                                            <td className="text-right">{element?.area_m2}</td>
                                        }
                                        
                                        <td className="text-right">{element?.percentage_shares}</td>
                                        <td className="text-right">{element?.total_shares_percentage}</td>
                                        {
                                            props?.externalCustomer ?
                                            "" : 
                                            <td className="text-right">{element?.total_area_percentage}</td>
                                        }
                                        <td className="text-left">{element?.business_id}</td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </Spin>
        </>    
    );
}

export default ListOfAllShareholdersPDF;